import { useIsAtOrNarrowerThan } from '~/shared/utils/useBreakpoint';
import { getLcn } from '~/utils/labeled-classnames';
import { publicStorageUrl } from '~/utils/paths';
import ChartsList from '../../charts/list/ChartsList';

export const bgUrl1 = publicStorageUrl('coaching/images/hero_bg/1.webp');

export default function Home() {
  const isXs = useIsAtOrNarrowerThan('xs');
  const lcn = getLcn({
    home: ''
  });

  return (
    <div className='styled flex flex-col gap-10'>

      <ChartsList />

    </div >

  );
}; 